import {
  Box,
  Editable as ChakraEditable,
  EditableInput,
  EditablePreview,
  Flex,
  Text,
  useEditableControls,
} from '@chakra-ui/react';
import React from 'react';
import { EditIcon, SaveIcon } from 'ui-components';

import {
  componentBoxStyles,
  componentInputStyles,
  componentPreviewStyles,
  componentWrapperStyles,
  containerStyles,
} from './Editable.styles';

interface EditableProps {
  defaultValue?: string;
  isDisabled?: boolean;
  isLoading?: boolean;
  isSaved?: boolean;
  onChange: (value: string) => void;
  onSubmit: (value: string) => void | Promise<void>;
  trackId?: string;
  value?: string;
}

export const Editable: React.FC<EditableProps> = ({
  defaultValue,
  isDisabled = false,
  isLoading,
  isSaved,
  onChange,
  onSubmit,
  trackId,
  value,
}) => {
  return (
    <ChakraEditable
      __css={containerStyles}
      data-testid="editable"
      defaultValue={defaultValue}
      isDisabled={isDisabled || isLoading}
      onChange={onChange}
      onSubmit={onSubmit}
      track-id={trackId}
      value={value}
    >
      <Flex {...componentWrapperStyles}>
        <EditablePreview
          data-testid="editable-preview"
          {...componentPreviewStyles}
        />
        <EditableInput data-testid="editable-input" {...componentInputStyles} />
        <EditableControls isDisabled={isDisabled} isSaved={isSaved} />
      </Flex>
    </ChakraEditable>
  );
};

interface EditableControlsProps {
  isDisabled?: boolean;
  isSaved?: boolean;
}

function EditableControls({ isDisabled, isSaved }: EditableControlsProps) {
  const { isEditing, getEditButtonProps } = useEditableControls();

  if (isDisabled) {
    return null;
  }

  return (
    <Box
      {...componentBoxStyles}
      // eslint-disable-next-line tailwindcss/no-custom-classname
      className="field-icon"
      opacity={isSaved ? 1 : 0}
    >
      {isSaved && !isEditing ? (
        <Flex gap={1} justifyContent="center" alignItems="center">
          <SaveIcon boxSize={4} color="primary.300" />
          <Text fontSize="md" fontWeight="400" color="primary.300">
            Saved to Foam
          </Text>
        </Flex>
      ) : !isEditing ? (
        <EditIcon
          boxSize={4}
          color="primary.300"
          cursor="pointer"
          {...getEditButtonProps()}
        />
      ) : null}
    </Box>
  );
}
